import { Injectable } from "@angular/core";
import { CanDeactivate } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { firstValueFrom } from "rxjs";
import { UnsavedChanges } from "@shared/models/interfaces";
import { ConfirmationComponent } from "@shared/components/confirm-dialog/confirm-dialog.component";
import { ConfirmDialogMessages } from "@data/confirm-dialog-messages.config";

type ConfirmClick = boolean | 'secondary';

@Injectable({ providedIn: 'root' })
export class UnsavedChangesFilter implements CanDeactivate<UnsavedChanges> {
  constructor(readonly dialog: MatDialog) {}

  async canDeactivate( component: UnsavedChanges ): Promise<boolean> {
    if (!component?.hasUnsavedChanges()) {
      return true;
    }

    const ref = this.dialog.open<ConfirmationComponent, any, ConfirmClick>(ConfirmationComponent, {
        autoFocus: false,
        data: ConfirmDialogMessages.NavAwayWithUnsavedChanges
      }
    );
  

    const result = await firstValueFrom(ref.afterClosed());
    if(result){
       const status = component.unholdAllHoldIds?.();
       return status === undefined || status;
    }
    return !!result;
  }

}